export default __webpack_public_path__ + "static/media/ing.7308b495.jpg";